<template>
  <div class="directionality-page">
    <LoadingForum v-if="isLoading" ref="loader" @loaded="finishLoading" :message="loadingMessage" class="full-screen-loader" />
    <div :class="{ 'loading-hidden': isLoading, 'loading-visible': !isLoading }">
      <header class="page-header">
        <h1 class="typo-headline-4 page-title">Direccionalidad de los mercados</h1>
        <p class="typo-body-1 page-subtitle">
          Análisis de tendencias en índices y sectores para identificar oportunidades de inversión.
        </p>
      </header>

      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell--span-12">
          <div v-if="indices_data_ready && sectors_data_ready">
            <!-- Tabs Section - Vanilla Implementation -->
            <section class="tabs-section">
              <div class="vanilla-tabs-container">
                <button
                  v-for="(item, index) in tab_obj" 
                  :key="index" 
                  @click="selectTab(item.tab_id)"
                  :class="['vanilla-tab-button', { 'active': tab_indexId === item.tab_id }]"
                >
                  {{ item.tab_name }}
                </button>
              </div>
            </section>
          
            <div class="tab-content">
              <div v-show="tab_indexId === 'indices'" class="tab-pane card">
                <h2 class="typo-headline-6 section-title">Direccionalidad por Índices</h2>
                <Indices 
                  :best_country="best_country" 
                  :indices_data="indices_data" 
                  :best_sector="best_sector" 
                  :sectors_data="sectors_data"/>
              </div>
              <div v-show="tab_indexId === 'sectores' && eurekers_values_ready" class="tab-pane card">
                <h2 class="typo-headline-6 section-title">Direccionalidad por Sectores</h2>
                <Sectores 
                  :best_sector="best_sector" 
                  :sectors_data="sectors_data" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import APICaller from "@/components/codeComponents/APICaller.js";
import Sectores from "@/components/directionality/Sectores.vue";
import Indices from "@/components/directionality/Indices.vue";
import LoadingForum from '@/components/stockchart/components/LoadingForum.vue';
import { mapGetters } from 'vuex';

export default {
  mixins:[APICaller],
  name: "Directionality",
  components: {
    Indices,
    Sectores,
    LoadingForum
  },
  data() {
    return {
      isLoading: true,
      loadingMessage: "Cargando direccionalidad de mercados...",
      eurekers_values : {},
      eurekers_values_ready: false,
      tab_indexId: "indices",
      tab_obj: [
        {
          tab_name: "Indices",
          tab_id: "indices"
        },
        {
          tab_name: "Sectores",
          tab_id: "sectores"
        }
      ],

      indices_data: {},
      indices_data_ready: false,
      best_country: {
        one_month: { title: "Mejor país 1 mes" },
        three_month: { title: "Mejor país 3 meses" },
        one_year: { title: "Mejor país 1 año" }
      },

      sectors_data: {},
      sectors_data_ready: false,
      best_sector: {
        one_month: { title: "Mejor sector 1 mes" },
        three_month: { title: "Mejor sector 3 meses" },
        one_year: { title: "Mejor sector 1 año" }
      },
      cachedTabState: {
        indices: null,
        sectores: null
      }
    };
  },
  mounted() {
    this._getDirectionalityData();
    this._getSectorsData();
    this._getSectorsEurekersValues();
    
    this._preloadSectoresData();
  },
  computed: {
    ...mapGetters(['_g_UserId']),
    ...mapGetters(["is_mobile_device"]),
  },
  methods: {
    selectTab(tabId) {
      if (tabId === 'sectores' && !this.eurekers_values_ready) {
        const tabButton = document.getElementById(tabId);
        if (tabButton) {
          tabButton.classList.add('loading-tab');
          setTimeout(() => {
            tabButton.classList.remove('loading-tab');
          }, 300);
        }
      }
      
      this.tab_indexId = tabId;
    },
    
    _preloadSectoresData() {
      if (!this.eurekers_values_ready && !this.sectors_data_ready) {
        // Already being loaded in mounted()
      }
    },
    
    finishLoading() {
      if (this.indices_data_ready && this.sectors_data_ready) {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },
    _getIndexTab(tab_id) {
      this.tab_indexId = tab_id;
    },
    _getDirectionalityData() {
      let success = response => {
        this.indices_data = response.data;
        this.indices_data_ready = true;
        this.checkDataReady();
      }

      let url = "/api/frontend/v1/eurekers-directionality/best-indices"

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('179', 'Error recuperando índices.');

      this._getAPICall(url, successHandler, failureHandler);
    },
    _getSectorsData() {
      let success = response => {
        const new_sectors_data = response.data;
        if (!new_sectors_data.eurekers_values) {
          new_sectors_data.eurekers_values = {};
        }
        
        if (this.eurekers_values && Object.keys(this.eurekers_values).length > 0) {
          // Use $set for robust reactivity if new_sectors_data is a new object
          this.$set(new_sectors_data, 'eurekers_values', this.eurekers_values);
        }
        this.sectors_data = new_sectors_data;
        
        this.sectors_data_ready = true;
        this.checkDataReady();
        console.log('[Directionality] _getSectorsData: sectors_data populated:', JSON.parse(JSON.stringify(this.sectors_data)));
      }

      let url = "/api/frontend/v1/eurekers-directionality/best-sectors"

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('180', 'Error recuperando información de sectores.');

      this._getAPICall(url, successHandler, failureHandler);
    },
    _getSectorsEurekersValues() {
      let success = response => {
        this.eurekers_values = response.data || {};
        
        if (!this.sectors_data) {
          this.sectors_data = {};
        }
        
        // Ensure eurekers_values key exists before setting, for reactivity
        if (!this.sectors_data.hasOwnProperty('eurekers_values')) {
            this.$set(this.sectors_data, 'eurekers_values', {});
        }
        this.$set(this.sectors_data, 'eurekers_values', this.eurekers_values);
        
        this.eurekers_values_ready = true;
        console.log('[Directionality] _getSectorsEurekersValues: Raw eurekers_values fetched:', JSON.parse(JSON.stringify(this.eurekers_values)));
        console.log('[Directionality] _getSectorsEurekersValues: sectors_data.eurekers_values after set:', JSON.parse(JSON.stringify(this.sectors_data.eurekers_values)));
      }

      let url = "/api/frontend/v1/eurekers-directionality/eurekers-tickers-sectors/" + this._g_UserId;

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('181', 'Error recuperando información de sectores.');

      this._getAPICall(url, successHandler, failureHandler);
    },
    checkDataReady() {
      if (this.indices_data_ready && this.sectors_data_ready) {
        if (this.$refs.loader) {
          this.$refs.loader.finishLoading();
        }
      }
    },
  }
};
</script>



<style lang="scss">
/* Global Page Styles */
.directionality-page {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Styles */
.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-title {
  color: var(--color-primary);
  margin-bottom: 8px;
}

.page-subtitle {
  color: var(--color-text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

/* Card base style for sections */
.card {
  background-color: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  padding: 30px;
  margin-bottom: 40px;
  border: 1px solid var(--color-outline);
}

/* Vanilla Tabs Implementation */
.tabs-section {
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
}

.vanilla-tabs-container {
  display: flex;
  gap: 10px;
  border-bottom: 2px solid var(--color-outline);
  padding-bottom: 0;
}

.vanilla-tab-button {
  background-color: transparent;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 1rem;
  font-weight: 500;
  transition: color 0.2s ease, border-bottom-color 0.2s ease;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  border-radius: 6px 6px 0 0;
}

.vanilla-tab-button:hover {
  color: var(--color-primary);
}

.vanilla-tab-button.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}

/* Section Styling */
.section-title {
  color: var(--color-text-primary);
  margin-top: 0;
  margin-bottom: 12px;
  border-bottom: 2px solid var(--color-primary);
  padding-bottom: 10px;
  display: inline-block;
}

/* Tab content optimization */
.tab-content {
  position: relative;
  min-height: 400px;
  width: 100%;
}

.tab-pane {
  width: 100%;
  transition: opacity 0.2s ease-in-out;
}

/* Add loading transitions */
.loading-hidden {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.loading-visible {
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

/* Make the loading indicator cover the full screen */
.full-screen-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: var(--color-background, #fff);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Prevent scrolling during loading */
body.loading-active {
  overflow: hidden;
}

/* Loading tab feedback */
.loading-tab {
  animation: pulse 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(0.98); }
  100% { transform: scale(1); }
}

/* Add hardware acceleration for smoother transitions */
.vanilla-tab-button {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* Typography helpers */
.typo-headline-4 { font-size: 2.125rem; font-weight: 500; line-height: 1.2; }
.typo-headline-5 { font-size: 1.5rem; font-weight: 500; line-height: 1.33; }
.typo-headline-6 { font-size: 1.25rem; font-weight: 500; line-height: 1.4; }
.typo-body-1 { font-size: 1rem; font-weight: 400; line-height: 1.5; }
.typo-body-2 { font-size: 0.875rem; font-weight: 400; line-height: 1.5; }
.typo-caption { font-size: 0.75rem; font-weight: 400; line-height: 1.66; }

/* Responsive Adjustments */
@media (max-width: 768px) {
  .directionality-page { 
    padding: 20px;
    width: auto;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .mdc-layout-grid__inner {
    margin-right: 0;
    margin-left: 0;
    width: 100%;
  }
  
  .mdc-layout-grid__cell--span-12 {
    padding-right: 0;
    padding-left: 0;
    width: 100%;
  }
  
  .card { 
    padding: 20px; 
    margin-bottom: 30px;
    width: 100%;
    box-sizing: border-box;
  }
  .vanilla-tabs-container { gap: 5px; overflow-x: auto; }
  .vanilla-tab-button { padding: 10px 15px; font-size: 0.9rem; }
}
</style>
